import { render, staticRenderFns } from "./MyNews.vue?vue&type=template&id=d4a83f32&scoped=true"
import script from "./MyNews.vue?vue&type=script&lang=js"
export * from "./MyNews.vue?vue&type=script&lang=js"
import style0 from "./MyNews.vue?vue&type=style&index=0&id=d4a83f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a83f32",
  null
  
)

export default component.exports